import { coreApi } from "./coreApi";

export const storeApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getSpecificStore: builder.query({
      query: (id) => ({
        url: `/administrator/stores/show/${id}`,
        method: "GET",
      }),
    }),
    getAllStores: builder.query({
      query: (query = `page=1&per_page=100`) => ({
        url: `/administrator/stores?${query}`,
        method: "GET",
      }),
      providesTags: ["Stores"],
    }),
  }),
});

export const { useGetSpecificStoreQuery, useGetAllStoresQuery } = storeApi;
